export const accountActivitiesCacheKeys = {
  getActivities: requestOptions => ['activities', requestOptions] as const
}
